function SlotSearchList() {
    return (
      <>
<div className="searchBoxCont">
	<input id="gameSearchBox" type="text" placeholder="Search" />
</div>
      </>
    )
  }
export default SlotSearchList